import { WritableDraft } from "immer";
import assign from "lodash/assign";
import compact from "lodash/compact";
import { getFilterByIdentifier } from "PFApp/components/filters_v2/helpers/get_filter_by_identifier";
import { resolveFilterUpdate } from "PFApp/components/filters_v2/helpers/resolve_filter_update";
import { FilterV2WithIdentifierAndUpdater } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import { FiltersV2 } from "PFTypes/filters_v2";

/**
 * Apply updatedFilter changes to the filter state in writable store state filters object
 *
 * @param filtersGroup - writable store state filters object
 * @param updatedFilter
 * @return Filter | undefined - returns updated filter if filter value was modified, undefined otherwise
 */
const applyFilterChanges = (
  filtersGroup: WritableDraft<FiltersV2>,
  updatedFilter: FilterV2WithIdentifierAndUpdater
) => {
  const currentFilter = getFilterByIdentifier(filtersGroup, updatedFilter);

  if (!currentFilter) {
    return;
  }

  const { data, valueChange } = resolveFilterUpdate(currentFilter, updatedFilter);
  assign(currentFilter, data);

  if (!valueChange) {
    return;
  }

  assign(currentFilter, valueChange);

  return currentFilter;
};

export const updateFilter = (
  draftState: WritableDraft<{ mainFilters: FiltersV2; childrenFilters: FiltersV2 }>,
  { isChildren, ...updatedFilter }: FilterV2WithIdentifierAndUpdater
) => applyFilterChanges(isChildren ? draftState.childrenFilters : draftState.mainFilters, updatedFilter);

export const updateFilters = (
  draftState: WritableDraft<{ mainFilters: FiltersV2; childrenFilters: FiltersV2 }>,
  filters: FilterV2WithIdentifierAndUpdater[]
) => compact(filters.map((updatedFilter) => updateFilter(draftState, updatedFilter)));
